import { useTranslate } from '@common/hooks'
import ModalFooter from '@common/widgets/ModalFooter'

import classNames from './styles.module.scss'


interface IProps {
  newApp: string,
  oldApp: string,
  slotId: number,
  onClose: () => void,
  onHide: () => void,
  isSubmitting: boolean,
}

export default function ConfirmationModal({
  newApp,
  oldApp,
  slotId,
  onClose,
  onHide,
  isSubmitting,
}: IProps): JSX.Element {
  const { translate, interpolate } = useTranslate()
  return (
    <>
      <p className={classNames.confirmationText} data-test="confirmation-text">
        {interpolate(translate('Installing %s in slot %s will replace the current application, %s.'), [newApp, slotId, oldApp])}
      </p>
      <p className={classNames.confirmationText} data-test="confirmation-text">
        {translate('Do you want to continue?')}
      </p>
      <ModalFooter
        isSubmitting={isSubmitting}
        onClose={onClose}
        onHide={onHide}
      />
    </>
  )
}
